import antdEnUS from 'antd/es/locale/en_US';
import axios from "axios";
import { env } from 'configs/EnvironmentConfig';

const fetchMessages = async () => {
  const response = await axios.get(process.env.NODE_ENV === 'production' ? env.IMG_SRC + '/locales/en_US.json' : 'https://apitest.tunimobile.com/locales/en_US.json'); // Replace with your URL
  if (response.status !== 200) {
    throw new Error(`Failed to load translations: ${response.statusText}`);
  }
  return await response.data;
};

const EnLang = {
  antd: antdEnUS,
  locale: 'en-US',
  fetchMessages,
};
export default EnLang;
